import React from 'react';
import { Link } from 'react-router-dom';
import DocPage from '../../components/DocPage/DocPage';

function AcceptableUse() {
  return (
    <DocPage title="Acceptable Use Policy" updated="Last updated: July 2026">
      <p>
        This Acceptable Use Policy ("Policy") sets out the rules for using Orbix's website, platform, and
        services (the "Services"). By accessing the Services, you agree to follow this Policy. It supplements
        our <Link to="/terms-of-services">Terms &amp; Conditions</Link>.
      </p>
      <p>
        We keep this Policy simple: use Orbix for its intended purpose, don't break the law, and don't
        interfere with other people's use of the platform.
      </p>

      <h2>Acceptable use</h2>
      <p>
        Orbix is built to help technicians, quality teams, and AI agents carry out and manage non-destructive
        testing (NDT) workflows. You may use the Services for legitimate business and professional purposes in
        connection with that work, in line with your agreement with us.
      </p>

      <h2>Prohibited use</h2>
      <p>You may not use the Services to:</p>
      <ul>
        <li>Violate any applicable law, regulation, or industry standard, or infringe the rights of others.</li>
        <li>Upload, store, or share content that is unlawful, fraudulent, defamatory, or that you don't have the right to share.</li>
        <li>Misrepresent inspection results, falsify records, or use the platform to conceal safety-relevant information.</li>
        <li>Attempt to gain unauthorized access to the Services, other users' accounts, or any connected systems or networks.</li>
        <li>Introduce malware, or otherwise disrupt, degrade, or interfere with the integrity or performance of the Services.</li>
        <li>Reverse engineer, scrape, or copy the Services except as expressly permitted by law or your agreement with us.</li>
        <li>Use the Services to build or train a competing product, or resell access without our written permission.</li>
        <li>Overload the platform with automated requests outside of documented, authorized integrations.</li>
      </ul>

      <h2>AI agents and automated access</h2>
      <p>
        Orbix supports the use of AI agents and automated workflows as part of the platform. When you use these
        features, you remain responsible for their output and for ensuring they operate within this Policy,
        applicable law, and any relevant NDT standards. Automated access must go through supported, authorized
        interfaces.
      </p>

      <h2>Enforcement</h2>
      <p>
        If we believe you have violated this Policy, we may suspend or terminate your access, remove offending
        content, and where appropriate notify the relevant authorities. We'll aim to give notice where we
        reasonably can, but we may act immediately in cases involving security, legal risk, or harm to others.
      </p>

      <h2>Reporting a concern</h2>
      <p>
        To report misuse or a security issue, contact us at{' '}
        <a href="mailto:security@orbix.com">security@orbix.com</a>.
      </p>
    </DocPage>
  );
}

export default AcceptableUse;
